import React from 'react';
import { Clock, Mail, Target, TrendingUp, Brain } from 'lucide-react';

const Results = () => {
  const outcomes = [
    {
      icon: <Clock className="h-6 w-6 text-burnt-orange" />,
      text: "Your schedule has breathing room again"
    },
    {
      icon: <Mail className="h-6 w-6 text-burnt-orange" />,
      text: "Your inbox feels manageable"
    },
    {
      icon: <Target className="h-6 w-6 text-burnt-orange" />,
      text: "Tasks stop slipping through cracks"
    },
    {
      icon: <TrendingUp className="h-6 w-6 text-burnt-orange" />,
      text: "Projects move without you pushing every step"
    },
    {
      icon: <Brain className="h-6 w-6 text-burnt-orange" />,
      text: "You have time to think, plan, and lead"
    }
  ];

  return (
    <section id="results" className="section-padding bg-gray-50">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            What you should expect to feel within weeks.
          </h2>
        </div>

        {/* Outcomes */}
        <div className="max-w-4xl mx-auto space-y-6 mb-12">
          {outcomes.map((outcome, index) => (
            <div 
              key={index}
              className="flex items-start space-x-4 p-6 bg-white rounded-xl card-shadow animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="p-2 bg-burnt-orange/20 rounded-full mt-1">
                {outcome.icon}
              </div>
              <p className="text-lg text-olive-brown leading-relaxed">
                {outcome.text}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="text-center">
          <p className="text-olive-brown/70">
            We don't promise perfection. We promise progress you can feel.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Results;